const SCROLL_ROOT_SELECTORS = [
  '.mat-drawer-content',
  '.mat-sidenav-content',
  '.main_wrapper'
];

/** Resets scroll for the panel's actual scroll containers (sidenav content), not just window. */
export function scrollAppToTop(): void {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  SCROLL_ROOT_SELECTORS.forEach(selector => {
    document.querySelectorAll<HTMLElement>(selector).forEach(element => {
      element.scrollTop = 0;
      element.scrollLeft = 0;
    });
  });
}
